// extracted by mini-css-extract-plugin
module.exports = {"subregionCell":"PEPs_subregionCell__EjCFj","territoryCell":"PEPs_territoryCell__lrhxu"};